<template>
  <div class="container-fluid">
    <div
      v-for="attribute in errors"
      v-bind:key="attribute"
      class="alert alert-danger"
    >
      <div v-for="error in attribute" v-bind:key="error">
        {{ error }}
      </div>
    </div>
    <h4 class="m-3">Добавление категории статей</h4>
    <el-form
      ref="form"
      :model="form"
      label-width="120px"
      id="uploadForm"
      name="uploadForm"
      enctype="multipart/form-data"
    >
      <el-form-item label="Название">
        <el-input v-model="form.title"></el-input>
      </el-form-item>
      <el-form-item label="Сортировка">
        <el-input v-model="form.sort"></el-input>
      </el-form-item>
      <el-form-item label="Активность">
        <el-checkbox v-model="form.activity"></el-checkbox>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="storeArticleSection()"
          >Добавить</el-button
        >
        <el-button @click="back()">Отмена</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data: function () {
    return {
      form: {
        title: "",
        slug: "",
        sort: 1,
        activity: true,
      },
      errors: [],
      status: 0,
    };
  },
  methods: {
    back() {
      this.$router.push("/article-sections");
    },
    storeArticleSection() {
      let data = {
        title: this.form.title,
        slug: this.form.slug,
        activity: this.form.activity,
        sort: this.form.sort,
      };

      axios
        .post("/blog/section", data)
        .then((response) => {
          this.status = response.status;
          this.$router.push("/article-sections");
        })
        .catch((errors) => {
          this.errors = errors.response.data.errors;

          if (errors.response.status === 401) {
            this.$router.push("/login");
          }
        });
    },
  },
};
</script>

<style scoped>
</style>